document.addEventListener('DOMContentLoaded', function () {
  var stages = document.querySelectorAll('[data-anim-wrap]');
  stages.forEach(function (stage, stageIndex) {
    var items = stage.querySelectorAll('[data-anim-item]');
    if (!items.length) return;

    var storageKey = stageIndex;
    var index = parseInt(localStorage.getItem(storageKey), 10);

    if (isNaN(index) || index >= items.length || index < 0) {
      index = 0;
    }

    items[index].classList.add('is-active');
    localStorage.setItem(storageKey, (index + 1) % items.length);
  });

  var successMsg = document.querySelector('.form-success:not(.hide)');
  if (successMsg) {
    var titleBar = successMsg.closest('.section--newsletter-wrapper')
      ?.querySelector('.title-bar');
    if (titleBar) {
      titleBar.classList.add('hide');
    }
  }

  var newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    var emailInput = newsletterForm.querySelector('input[name="contact[email]"]');
    var errorMsg = document.getElementById('newsletter-error');
    var emailPattern = /^[^\s@.]+(\.[^\s@.]+)*@[^\s@]+\.[^\s@]+$/;


    if (emailInput) {
      newsletterForm.addEventListener('submit', function (e) {
        var emailValue = emailInput.value.trim().toLowerCase();

        if (!emailValue || !emailPattern.test(emailValue)) {
          e.preventDefault();
          e.stopImmediatePropagation();

          if (errorMsg) {
            errorMsg.classList.remove('hide');
            document.querySelector('.newsletter-spinner').classList.add('hide');
            document.querySelector('#newsletter-wrapper').classList.remove('hide');
          }
          emailInput.classList.add('input-error');
          emailInput.focus();
          return false;
        }

        if (errorMsg) errorMsg.classList.add('hide');
      });

      emailInput.addEventListener('input', function () {
        if (errorMsg) errorMsg.classList.add('hide');
        emailInput.classList.remove('input-error');
      });
    }
  }
});